import { FunctionComponent } from "react";
import { connect } from "react-redux";
// import { showSnackbarAction } from "../../../Redux/actions";
// import styles from "../../BulkEditModal/BulkEditModal.module.css";
import styles from "./AudioPlayer.module.css";
// import "../../../Screens/AuditLogs/AuditLog.css";
// import Loading from "../../../Components/Loading/Loading";
import Backdrop from "../../Components/Backdrop/Backdrop";
import { motion, AnimatePresence } from "framer-motion";
import { IoIosClose } from "react-icons/io";
// import Label from "../../../Components/Label";
// import TextInput from "../../../Components/TextInput/TextInput";
import { themeColors } from "../../Components/theme";
// import axios from "axios";
// import { url } from "../../../Values/constants";
// import axiosHandler from "../../../Services/axiosHandler";
// import { setUser } from "../../../Redux/actions";

type props = {
    close: () => void;
    open: boolean;
    url: string;
    theme?: any;
    user?: any;
};

const dropIn = {
    hidden: {
        y: "-100vh",
        opacity: 1,
    },
    visible: {
        y: "0",
        opacity: 1,
        transition: {
            duration: 1,
            type: "spring",
            damping: 25,
            stiffness: 500,
        },
    },
};

const AudioPlayer: FunctionComponent<props> = ({
    close,
    open,
    url,
    theme,
    user,
}) => {
    // const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);
    // const [newMobileNumber, setNewMobileNumber] = useState("");

    // const dispatcher = useDispatch();

    const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark };

    return (
        <>
            {/* {load === true && <Loading />} */}
            <AnimatePresence>
                {open &&
                    <Backdrop>
                        <motion.div
                            key="modal"
                            className="card p-4 shadow rounded"
                            style={{
                                position: "absolute", minWidth: "400px",
                                ...containerStyles
                            }}
                            variants={dropIn}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                        >
                            <div className={styles.cross} onClick={close}>
                                <IoIosClose size={35} color={"#808080"} />
                            </div>
                            <div className={styles.audioPlayerContainer}>
                                <audio controls autoPlay>
                                    <source src={url} type="audio/mpeg" />
                                    Your browser does not support the audio element.
                                </audio>
                                {/* <div className={styles.downloadButton}>
                                    <a href={"https://www2.cs.uic.edu/~i101/SoundFiles/preamble10.wav"} download>
                                        Download Audio
                                    </a>
                                </div> */}
                            </div>
                        </motion.div>
                    </Backdrop>
                }
            </AnimatePresence>
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        theme: state.theme.isLightMode,
        user: state.user.data,
    };
};

export default connect(mapStateToProps)(AudioPlayer);